<template>
  <div class="d-inline-block">
    <!-- Button trigger modal -->
    <button type="button" class="btn btn-sm btn-outline-light" @click="show">
      <fa icon="edit" fixed-width />
      Edit
    </button>

    <!-- Modal -->
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content" style="max-height: 600px;">
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="text" class="col-form-label">Edit Description:</label>
                <button type="button" class="close" aria-label="Close" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <textarea v-model="text" class="form-control" maxlength="3000" rows="5"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="save">
              <fa icon="edit" fixed-width />
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: {
    isLoading: Boolean,
    investigation: Object,
  },
  data() {
    return {
      text: null,
    };
  },
  methods: {
    reset() {
      this.text = null;
    },
    show() {
      this.reset();
      this.text = this.investigation.description;
      $(this.$refs.modal).modal("show");
    },
    hide() {
      $(this.$refs.modal).modal("hide");
    },
    save() {
      const payload = {
        text: this.text,
      };

      this.$axios
        .put(`/v1/organizations/${this.investigation.organizationId}/investigations/${this.investigation.investigationId}/description`, payload)
        .then(() => {
          this.hide();
          this.reset();
          this.$emit("reload");
        })
        .catch(err => this.$emit("error", err));
    },
  },
};
</script>
